import { render, staticRenderFns } from "./ResearchListYjjM.vue?vue&type=template&id=8ae50058&scoped=true&"
import script from "./ResearchListYjjM.vue?vue&type=script&lang=js&"
export * from "./ResearchListYjjM.vue?vue&type=script&lang=js&"
import style0 from "./ResearchListYjjM.vue?vue&type=style&index=0&id=8ae50058&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae50058",
  null
  
)

export default component.exports